
export const CONTROL_STATUS_CREATED = 'opprettet';
export const CONTROL_STATUS_STARTED = 'startet';
export const CONTROL_STATUS_NEEDS_ADDITIONAL_REPORT = 'trenger_tilleggsrapport';
export const CONTROL_STATUS_SUBMITTED = 'innsendt';
export const CONTROL_STATUS_CANCELLED = 'avsluttet';
export const CONTROL_STATUS_CLOSED = 'lukket';

export function getControlStatusString(status) {
  if (!status) return '';
  return (status.charAt(0).toUpperCase() + status.substring(1)).replace('_', ' ');
}

const dateFormat = new Intl.DateTimeFormat('nb-NO', {
  year: 'numeric', month: '2-digit', day: '2-digit',
});
const dateTimeFormat = new Intl.DateTimeFormat('nb-NO', {
  year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric',
});


// A hacky solution to make Safari parse date strings correctly.
// It works using format 'yyyy/MM/dd', not with 'yyyy-MM-dd'.
export const convertDateStrToUseSlash = (dateStr) => {
  if (dateStr) {
    if (typeof dateStr === 'string') {
      return dateStr.replace(/-/g, '/');
    }
  }
  return dateStr;
};

export const formatCurrentDate = () => dateFormat.format(new Date());

export const formatDate = (dateStr) => {
  if (dateStr) {
    const date = new Date(convertDateStrToUseSlash(dateStr));
    return dateFormat.format(date);
  }
  return '';
};

export const formatDateTime = dateStr => (
  dateStr ? dateTimeFormat.format(new Date(convertDateStrToUseSlash(dateStr))) : ''
);

export const formatDatePeriod = (fromDateStr, toDateStr) => {
  const fromDate = fromDateStr != null && fromDateStr !== ''
    ? dateFormat.format(new Date(convertDateStrToUseSlash(fromDateStr))) : '';
  const toDate = toDateStr != null && toDateStr !== ''
    ? dateFormat.format(new Date(convertDateStrToUseSlash(toDateStr))) : '';

  return `${fromDate} - ${toDate}`;
};

export const formatLicenseDatePeriod = (license) => {
  if (!license.isAmbulatory) {
    return formatDatePeriod(license.validFrom, license.validTo);
  }

  const licensePeriods = [];
  license.dates.forEach((licensePeriod) => {
    licensePeriods.push(formatDatePeriod(licensePeriod.from, licensePeriod.to));
  });

  return licensePeriods.join(', ');
};

export const getLicenseTypeLabel = (licenseType) => {
  if (licenseType === 'skjenk') return 'Skjenking av alkohol';
  if (licenseType === 'salg') return 'Salg av alkohol';
  if (licenseType === 'tobakk') return 'Tobakkssalg';
  if (licenseType === 'tobakk-midlertidig') return 'Tobakkssalg (midlertidig)';
  if (licenseType === 'ea-skjenk') return 'Enkeltanledning - skjenking av alkohol';
  if (licenseType === 'ea-salg') return 'Enkeltanledning - salg av alkohol';
  return '';
};

export const getLicenseTypeLabelShort = (licenseType) => {
  if (licenseType === 'skjenk') return 'Skjenk';
  if (licenseType === 'salg') return 'Salg';
  if (licenseType === 'tobakk') return 'Tobakk';
  if (licenseType === 'tobakk-midlertidig') return 'Tobakk (midlertidig)';
  if (licenseType === 'ea-skjenk') return 'Enkeltanledning skjenk';
  if (licenseType === 'ea-salg') return 'Enkeltanledning salg';
  return '';
};

export const dateTimeStrToHourAndMin = (dateTimeStr, convertFromGMT, displayAsCET) => {
  if (dateTimeStr && dateTimeStr !== '') {
    let dateTimeStrWithTZ = dateTimeStr;
    if (convertFromGMT && dateTimeStr.indexOf('Z') < 0) {
      dateTimeStrWithTZ += 'Z';
    }

    const date = new Date(convertDateStrToUseSlash(dateTimeStrWithTZ));

    const options = {
      hour: '2-digit',
      minute: '2-digit',
    };
    if (displayAsCET) {
      options.timeZone = 'CET';
    }
    return date.toLocaleTimeString('nb-NO', options);
  }
  return '';
};

export const isElementInList = (
  list, sysId, sysIdFieldName,
) => list.filter(c => c[sysIdFieldName] === sysId).length > 0;

export const getElementBySysId = (elements, sysId) => {
  let match = null;
  if (elements != null) {
    elements.forEach((element) => {
      if (element.sysId === sysId) {
        match = element;
      }
    });
  }
  return match;
};

export const getLicenseListFromLicenseSysIDs = (allLicenses, sysIDs) => {
  const licenses = [];
  if (sysIDs != null) {
    sysIDs.forEach((sysId) => {
      const license = getElementBySysId(allLicenses, sysId);
      if (license) {
        licenses.push(license);
      }
    });
  }
  return licenses;
};

export const getObjectByFieldValue = (objList, fieldName, fieldValue) => {
  let match = null;
  if (objList != null) {
    objList.forEach((obj) => {
      if (obj[fieldName] === fieldValue) {
        match = obj;
      }
    });
  }
  return match;
};

export const getSysIdListFromObjectList = (objList, sysIdFieldName) => {
  const sysIDs = [];
  if (objList != null) {
    objList.forEach((obj) => {
      sysIDs.push(obj[sysIdFieldName]);
    });
  }
  return sysIDs.join(',');
};

export const getControllersListCommaSep = (controllers) => {
  let str = '';
  if (controllers) {
    controllers.forEach((controller) => {
      if (str !== '') str += ', ';
      str += `${controller.firstName} ${controller.lastName} (${controller.controllerNumber})`;
    });
  }
  return str;
};

export const getWorkPlanFromAssignmentList = (assignments, workPlanSysId) => {
  let match = null;
  if (assignments && workPlanSysId && workPlanSysId !== '') {
    assignments.forEach((assignment) => {
      const workPlan = getElementBySysId(assignment.workPlans, workPlanSysId);
      if (workPlan != null) {
        match = workPlan;
      }
    });
  }
  return match;
};

export function setDateTimeToMidnight(date) {
  if (date == null) return null;

  date.setHours(0);
  date.setMinutes(0);
  return new Date(
    date.getTime() - date.getTimezoneOffset() * 60000,
  );
}

export function getLicenseHeader(license, long) {
  const { name } = license.location;
  let licenseTypeShort = '';
  if (license.licenseType === 'skjenk') licenseTypeShort = long ? 'Skjenk' : 'SK';
  if (license.licenseType === 'salg') licenseTypeShort = long ? 'Salg' : 'SA';
  if (license.licenseType.startsWith('tobakk')) licenseTypeShort = long ? 'Tobakk' : 'T';
  if (license.licenseType === 'ea-skjenk') licenseTypeShort = long ? 'Enkeltanledning skjenk' : 'EA-SK';
  if (license.licenseType === 'ea-salg') licenseTypeShort = long ? 'Enkeltanledning salg' : 'EA-SA';
  return `${name} (${licenseTypeShort})`;
}

export function getLocationName(license) {
  return (license && license.location && license.location.name && license.location.name !== '')
    ? license.location.name : '(sted uten navn)';
}

export function getLocationNameFromLicenseList(allLicenses, licenseSysID) {
  const license = getObjectByFieldValue(allLicenses, 'sysId', licenseSysID);
  if (license) {
    return getLocationName(license);
  }
  return '';
}

export function getWorkPlanStatusText(workPlan) {
  let areAllControlsDone = true;

  for (let i = 0; i < workPlan.licensesSysId.length; i += 1) {
    const licenseSysID = workPlan.licensesSysId[i];

    let foundCompletedControlForLicense = false;
    for (let j = 0; j < workPlan.controls.length; j += 1) {
      const control = workPlan.controls[j];
      if (control.licenseSysId === licenseSysID
        && (control.status === CONTROL_STATUS_CANCELLED
          || control.status === CONTROL_STATUS_CLOSED
          || control.status === CONTROL_STATUS_SUBMITTED)
      ) {
        foundCompletedControlForLicense = true;
        break;
      }
    }
    if (!foundCompletedControlForLicense) {
      areAllControlsDone = false;
      break;
    }
  }

  if (areAllControlsDone) {
    return 'Fullført';
  }
  return workPlan.workSessions.length > 0 || workPlan.controls.length > 0 ? 'Startet' : 'Ikke startet';
}

export function getActiveControl(controls) {
  let match = null;
  if (controls && controls instanceof Array) {
    controls.forEach((control) => {
      if (control.status !== CONTROL_STATUS_SUBMITTED
        && control.status !== CONTROL_STATUS_CLOSED
        && control.status !== CONTROL_STATUS_CANCELLED) {
        match = control;
      }
    });
  }
  return match;
}

export function getMostRecentCompletedControl(controls) {
  let mostRecent = null;
  if (controls && controls instanceof Array) {
    controls.forEach((control) => {
      const isCompleted = control.status === CONTROL_STATUS_SUBMITTED
        || control.status === CONTROL_STATUS_CLOSED
        || control.status === CONTROL_STATUS_CANCELLED;

      if (isCompleted
        && (!mostRecent || new Date(convertDateStrToUseSlash(control.stopTime))
        > new Date(convertDateStrToUseSlash(mostRecent.stopTime)))) {
        mostRecent = control;
      }
    });
  }
  return mostRecent;
}

export function getAllElementsExceptOne(controls, exceptionElement) {
  const res = [];
  if (controls && controls instanceof Array) {
    controls.forEach((control) => {
      if (!exceptionElement || exceptionElement.sysId !== control.sysId) {
        res.push(control);
      }
    });
  }
  return res;
}

export function getViolationSeverityStr(violationSeverityCode) {
  if (violationSeverityCode === 0) return 'Ingen';
  if (violationSeverityCode === 1) return 'Mindre';
  if (violationSeverityCode === 2) return 'Grovere';
  return '';
}


export function getCompletedControlLabel(
  showIsControlCompleted,
  workPlan,
  workPlanList,
  licenseSysID,
) {
  if (!showIsControlCompleted) {
    return '';
  }

  if (workPlan) {
    return getIsControlCompletedLabelFromWorkPlan(workPlan, licenseSysID);
  }
  return getIsControlCompletedLabelFromWorkPlanList(workPlanList, licenseSysID);
}

function getIsControlCompletedLabelFromWorkPlan(workPlan, licenseSysId) {
  if (!workPlan || !workPlan.controls) return '';
  const control = getObjectByFieldValue(workPlan.controls, 'licenseSysId', licenseSysId);
  return getIsControlCompletedLabel(control);
}

function getIsControlCompletedLabelFromWorkPlanList(workPlanList, licenseSysId) {
  if (!workPlanList) {
    return '';
  }

  for (let i = 0; i < workPlanList.length; i += 1) {
    const workPlan = workPlanList[i];
    if (workPlan.controls) {
      const control = getObjectByFieldValue(workPlan.controls, 'licenseSysId', licenseSysId);
      if (control) {
        return getIsControlCompletedLabel(control);
      }
    }
  }

  return 'Nei';
}

function getIsControlCompletedLabel(control) {
  if (control) {
    if (control.status === CONTROL_STATUS_SUBMITTED
      || control.status === CONTROL_STATUS_CLOSED
      || control.status === CONTROL_STATUS_CANCELLED) {
      return 'Ja';
    }
    if (control.status === CONTROL_STATUS_NEEDS_ADDITIONAL_REPORT) {
      return 'Ja (trenger tilleggsrapport)';
    }
  }

  return 'Nei';
}


function sortByNewestDateOrTime(a, b, fieldName) {
  if (a[fieldName] > b[fieldName]) {
    return -1;
  }
  if (a[fieldName] < b[fieldName]) {
    return 1;
  }
  return 0;
}

function sortByNewestDateOrTimeStr(a, b, fieldName) {
  const dateA = new Date(convertDateStrToUseSlash(a[fieldName]));
  const dateB = new Date(convertDateStrToUseSlash(b[fieldName]));

  if (dateA > dateB) {
    return -1;
  }
  if (dateA < dateB) {
    return 1;
  }
  return 0;
}

function sortAlphabetically(a, b, fieldName, isSnObj) {
  let valueA = a[fieldName];
  let valueB = b[fieldName];

  if (isSnObj) {
    valueA = valueA.value;
    valueB = valueB.value;
  }

  if (valueA > valueB) {
    return -1;
  }
  if (valueA < valueB) {
    return 1;
  }
  return 0;
}

export function goBack(history) {
  const path = history.location.pathname.split('/');
  const s = path.slice(0, path.length - 1).join('/');
  history.replace(s);
}

export function dateTimeToString(dateTime, convertFromUTCToLocal) {
  const offsetMs = convertFromUTCToLocal ? dateTime.getTimezoneOffset() * 60 * 1000 : 0;
  const dateTimeConverted = new Date(dateTime.getTime() - offsetMs);
  return dateTimeConverted.toISOString().slice(0, 19).replace('T', ' ');
}

export function getCurrentLocalDateTimeStr() {
  const now = new Date();
  return dateTimeToString(now, true);
}

export function isDateStrInPast(dateStr) {
  const date = new Date(convertDateStrToUseSlash(dateStr));
  if (!date) {
    return false;
  }
  const now = new Date();
  return date < now;
}

export function sortByNewestStartTime(a, b) { return sortByNewestDateOrTime(a, b, 'startTime'); }
export function sortByNewestStart(a, b) { return sortByNewestDateOrTime(a, b, 'start'); }
export function sortByNewestFromTime(a, b) { return sortByNewestDateOrTime(a, b, 'fromDate'); }
export function sortByNewestDate(a, b) { return sortByNewestDateOrTime(a, b, 'date'); }
export function sortByNewestFromStr(a, b) { return sortByNewestDateOrTimeStr(a, b, 'from'); }
export function sortByNumberAlphabetically(a, b) { return sortAlphabetically(a, b, 'number', true); }
